import { SECOND_AUTH_NONE } from './components/SecondAuth/consts';
import * as productConsts from '@/const/product';

export const IS_LOCAL = window.XCConfig.VUE_APP_ENV === 'local';
export const LOCAL_APP_URL = 'https://d-res-cloud.xinchao.com:8082/portal/xauth';

export const TEST_CARD_KEY = '78646a6178646a614858533138194664';
export const TEST_CARD_CERT
  = '30820246308201EBA00302010202080B11000000000126300C06082A811CCF5501837505003031310B300906035504061302636E310D300B060355040A130478646A61311330110603550403130A58646A61537562436133301E170D3139303632343032323534365A170D3337313030383031313231315A3078310B300906035504061302636E311F301D060355040A131658696E44614A6965416E20436F72706F726174696F6E310F300D060355040B13067573626B65793137303506035504030C2E78696E6368616F30315F37383634364136313738363436413631343835383533333133383139343636345F656E633059301306072A8648CE3D020106082A811CCF5501822D03420004B843CA3C49084D36B5C05C2D54D43493F724507F14E0BF488B68E7A922F1236DE8B2D77500D9A52BA83F6C2D0BB754F14981FD18A8FE9D82EE090A6932FBEE77A381A33081A0301F0603551D23041830168014F36B250711214347611294CDC63381ED463797FC301D0603551D0E041604142F3E7AA7791AA05B54C7CBE93B1927FBA707D5C230090603551D130402300030460603551D1F043F303D303BA039A0378635687474703A2F2F3132372E302E302E312F43726C446F776E6C6F61643F64703D557365724341302E63726C266361416C673D322E30300B0603551D0F0404030203B8300C06082A811CCF5501837505000347003044022018AA85CAE558C2440CB65373DF48577D80CF7033B649D04253BA9BE43C3E672D02206A3DD050528B88651475BBE645BE80EBB34344C43D2188C992A2C7E52D347118';

// 本地开发环境下，成功登录后会直接加载这个配置的产品
export const LOCAL_PRODUCT = {
    deepJoin: false,
    collect: true,
    domain: LOCAL_APP_URL,
    redirect: LOCAL_APP_URL,
    productClusterId: '1',
    productCode: 'msp_system',
    productId: 1,
    productName: '本地开发用',
    initPath: '',
    productBoxTypeEnum: productConsts.BOX_TYPE_EMBEDDED,
    // 配置二次验证的方式
    secondAuth: SECOND_AUTH_NONE,
    agentId: null,
    description: '开发使用',
    iconUrl: null,
    productAuthorityEnum: 2,
    secret: null,
};
